import axiosInstance from "@/api/axiosInstance";
import {
  FetchEventAttendancesRequest,
  FetchEventAttendancesResponse,
} from "./types";

export const fetchEventAttendances = async (
  requestData: FetchEventAttendancesRequest,
): Promise<FetchEventAttendancesResponse> => {
  const url = `/api/private/event-sessions/${requestData.uuid}/attendances`;

  const response = await axiosInstance.get<FetchEventAttendancesResponse>(url, {
    params: {
      searchTerm: requestData.searchTerm,
      sortOrder: requestData.sortOrder,
      sortBy: requestData.sortBy,
      page: requestData.page,
      pageSize: requestData.pageSize,
      statusId: requestData.statusId,
    },
  });

  return response.data;
};
